import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import GoogleLogIn from "../GoogleLogIn";
import FacebookLogIn from "../FacebookLogIn";
import { ReactComponent as LockIcon } from "../../inlineSvgs/lock.svg";
import { ReactComponent as EmailIcon } from "../../inlineSvgs/email.svg";
import { ReactComponent as EyeIcon } from "../../inlineSvgs/eye.svg";
import { ReactComponent as CallIcon } from "../../inlineSvgs/call.svg";
import { ReactComponent as UserIcon } from "../../inlineSvgs/user.svg";
import { Link } from "react-router-dom";
import { signUp } from "../../api";
import { showNotification } from "../../config";

const SignUpForm = () => {
  const [passIsHide, setPassIsHide] = useState(true);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    defaultValues: {
      userName: "",
      userSurname: "",
      email: "",
      password: "",
      phone: "",
    },
  });

  const redirect = useNavigate();

  const togglePassIsHide = () => {
    setPassIsHide(!passIsHide);
  };

  const onSubmit = async (data) => {
    const formatedData = {
      email: data.email,
      password: data.password,
      firstName: data.userName,
      lastName: data.userSurname,
      phone: "" + data.phone.replace(/[^+\d]/g, ""),
    };

    const res = await signUp(formatedData)
      .then((res) => {
        if (res || res === "") {
          localStorage.setItem("registerUserPhone", formatedData.phone);
          localStorage.setItem("registerUserEmail", formatedData.email);
          redirect("/verify-phone");
        }
      })
      .catch((err) => {
        if (err.response?.data?.invalidParams?.[0]) {
          showNotification(err.response?.data?.invalidParams[0]);
        } else if (err.response.data.title) {
          showNotification(err.response.data.title);
        }
      });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="row">
        <div>
          <label htmlFor="userName">Name</label>
          <div className={errors.userName ? "input-wrapper error" : "input-wrapper"}>
            <div className="icon-wrapper">
              <UserIcon />
            </div>
            <input
              id="userName"
              type="text"
              placeholder="Enter your Name"
              {...register("userName", {
                required: { value: true, message: "The field cannot be left and must contain only letters" },
                pattern: {
                  message: "The field cannot be left and must contain only letters",
                  value: /^[a-zA-Z-]{1,50}$/,
                },
              })}
            />
            {errors.userName && <p className="errors">{errors.userName.message}</p>}
          </div>
        </div>
        <div>
          <label htmlFor="userSurname">Surname</label>
          <div className={errors.userSurname ? "input-wrapper error" : "input-wrapper"}>
            <div className="icon-wrapper">
              <UserIcon />
            </div>
            <input
              id="userSurname"
              type="text"
              placeholder="Enter your Surname"
              {...register("userSurname", {
                required: { value: true, message: "The field cannot be left and must contain only letters" },
                pattern: {
                  message: "The field cannot be left and must contain only letters",
                  value: /^[a-zA-Z-]{1,50}$/,
                },
              })}
            />
            {errors.userSurname && <p className="errors">{errors.userSurname.message}</p>}
          </div>
        </div>
      </div>

      <label htmlFor="email">Email Address</label>
      <div className={errors.email ? "input-wrapper error" : "input-wrapper"}>
        <div className="icon-wrapper">
          <EmailIcon />
        </div>
        <input
          id="email"
          type="email"
          placeholder="Enter your email"
          {...register("email", {
            required: { value: true, message: "Enter a valid email address. The field cannot be empty." },
            pattern: {
              message: "Enter a valid email address. The field cannot be empty.",
              value:
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            },
          })}
        />
        {errors.email && <p className="errors">{errors.email.message}</p>}
      </div>

      <div className="row">
        <div>
          <label htmlFor="password">Password</label>
          <div className={errors.password ? "input-wrapper error" : "input-wrapper"}>
            <div className="icon-wrapper">
              <LockIcon />
            </div>
            <input
              id="password"
              autoComplete="off"
              type={passIsHide ? "password" : "text"}
              placeholder="Enter your password"
              {...register("password", {
                required: {
                  value: true,
                  message:
                    "Password must be least 8 characters long and contain a combination of letters, numbers, special characters.",
                },
              })}
            />
            <button type="button" onClick={togglePassIsHide}>
              <EyeIcon />
            </button>
            {errors.password && <p className="errors">{errors.password.message}</p>}
          </div>
        </div>

        <div>
          <label htmlFor="phone">Phone Number</label>
          <div className={errors.phone ? "input-wrapper error" : "input-wrapper"}>
            <div className="icon-wrapper">
              <CallIcon />
            </div>
            <input
              id="phone"
              type="tel"
              placeholder="Enter your phone number"
              {...register("phone", {
                required: { value: true, message: "Please enter a valid phone number. The field cannot be empty." },
                pattern: {
                  message: "Please enter a valid phone number. The field cannot be empty.",
                  value:
                    /^((8|\+374|\+994|\+995|\+375|\+7|\+380|\+38|\+996|\+998|\+993|\+[0-9][0-9][0-9])[\- ]?)?\(?\d{3,5}\)?[\- ]?\d{1}[\- ]?\d{1}[\- ]?\d{1}[\- ]?\d{1}[\- ]?\d{1}(([\- ]?\d{1})?[\- ]?\d{1})?$/,
                },
              })}
            />
            {errors.phone && <p className="errors">{errors.phone.message}</p>}
          </div>
        </div>
      </div>

      <div className="buttons-section">
        <div className="submit-section">
          <button type="submit" className="beauty-btn fill">
            Create Account
          </button>
          <Link to="/login" className="beauty-btn border">
            Login to Your Account
          </Link>
        </div>
        <div className="delimiter">Or login using</div>
        <div className="login-by-social">
          <GoogleLogIn />
          <FacebookLogIn />
        </div>
      </div>
    </form>
  );
};

export default SignUpForm;
